import React, { Component} from 'react'



//Custom Components
import SplashScreen from '../ui/takeQuiz/SplashScreen'
import LoadingSpinner from '../components/LoadingSpinner'

export default class TakeTest extends Component {
    constructor(props)
    {
        super(props);

        this.state={
            quizId:parseInt(this.props.match.params.quizId, 10),
            quizName:this.props.match.params.quiz_name,
            showSplashScreen:true,                              //Change this in ComponentWillMount to False if the Quiz is being Resumed
            quizLoading:true
        }

        this.onStartClick = this.onStartClick.bind(this);
    }


    UNSAFE_componentWillMount()
    {
        this.getQuizFromServer();   //This should not be called first, Quiz Save State should be Retrived First 
    }

    getQuizFromServer()
    {
        this.setState({quizLoading:true})   //Set QuizLoading State to True, if not already done
        const payload = {
            quiz_id:        this.state.quizId,
            user_id:        this.props.globalProperties.currentUserData.USER_NAME,
            quiz_name:      this.state.quizName,
            quiz_attempt:   0
        }
        let responsePromise = this.props.apiService({method: 'POST',
        url: '/testHandler',
        data: payload});

        responsePromise.then(res => {
            if(res.data.data.data !== null){                
                let quizData = res.data.data;
                console.debug('quizData',quizData);
                //this.prepareData(quizData)
            }
            else if(res.data.data.flag !== "OK"){
                //User Notification Manager to Show and Error            
            }
        }).catch(error => {
            console.error("Error when getting Quiz Data",error);
            //User Notification Manager to Show and Error                  
        });;
    }

    onStartClick()
    {
        //Start Quiz on Click and Disable Splash Screen
        this.setState({showSplashScreen:false});

    }


    render(){
        if(this.state.quizLoading)
        {
            return(
                <LoadingSpinner />
            );
        }

        if(this.state.showSplashScreen)
        {
            return(
                <SplashScreen
                    onStartClick={this.onStartClick} 
                    title={this.state.quizName} 
                    splashText="Dummy Data" >
                </SplashScreen>
            );
        }
    }
}
